import { render, staticRenderFns } from "./TopNavButton.vue?vue&type=template&id=4f378ac3&"
import script from "./TopNavButton.vue?vue&type=script&lang=ts&"
export * from "./TopNavButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports